import React, { useState } from "react";
import { Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { useAppApi } from "@/App";
import { useRequest } from "@components/AppHook";
import { DevForm } from "@components/Forms/Fields";
import { RenderForm } from "@components/Forms/Render";
import { DevModal } from "@components/Helpers";
import { ListingCard } from "@components/Pages";
import { money_fmt, url_reverse } from "@components/Utils";

export default function DeveloperReceipts() {
    const { t } = useTranslation();
    const { apiData, setApiData, apiUrl } = useAppApi(url_reverse("api:finstatements:developer_receipts"));
    const { api_post } = useRequest();
    const [createReceiptModal, setCreateReceiptInfo] = useState(false);

    if (!apiData) return;
    const loadModalData = (ev, mdm_id, action) => {
        api_post(null, apiUrl, {
            params: {
                action,
                mdm_id,
                month: apiData.forms_data.main.data.month,
                year: apiData.forms_data.main.data.year,
            },
            then: (resp) => {
                if (resp.status === "ok") {
                    setCreateReceiptInfo(resp);
                }
            },
        });
    };

    const bulkMakeFisc = (action) => {
        api_post(null, apiUrl, {
            params: {
                action,
                month: apiData.forms_data.main.data.month,
                year: apiData.forms_data.main.data.year,
            },
        });
    };

    return (
        <>
            <ListingCard header={t("Отчет по чекам разработчиков")}>
                <RenderForm colLabel={2} colField={10} submitButtonText={t("Найти")} submitMethod="get" />
                {!apiData.disabled && apiData.object_list.some((o) => !o.receipt_id) && (
                    <div style={{ float: "right" }}>
                        <DevForm.Button
                            variant={"success"}
                            size="sm"
                            name="action"
                            onClick={() => bulkMakeFisc("bulk_make_receipt")}
                        >
                            {t("Сформировать все чеки")}
                        </DevForm.Button>
                    </div>
                )}
                <Table hover responsive className="dmg-table">
                    <thead>
                        <tr>
                            <th style={{ width: "10%" }}>MDM</th>
                            <th style={{ width: "25%" }}>{t("Разработчик")}</th>
                            <th style={{ width: "10%" }}>{t("Сумма дохода разработчика")}</th>
                            <th style={{ width: "10%" }}>{t("Вознаграждение")}</th>
                            <th style={{ width: "35%" }}>{t("Чек")}</th>
                            <th style={{ width: "20%" }}>{t("Выдать чек за месяц")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {apiData.object_list?.map((o) => {
                            return (
                                <tr key={`object_list${o.o2o_developerfinance__mdm_id}`}>
                                    <td>{o.o2o_developerfinance__mdm_id}</td>
                                    <td>
                                        <a href={url_reverse("devs:edit", { dev_id: o.id })}>{o.company_ru || "---"}</a>
                                    </td>
                                    <td>{o.total_royalty}</td>
                                    <td>{o.agent_fee_sum}</td>
                                    <td>{o.receipt_id}</td>
                                    <td>
                                        {o.o2o_developerfinance__mdm_id && (
                                            <>
                                                <DevForm.Button
                                                    variant={apiData.disabled || o.receipt_id ? "primary" : "success"}
                                                    size="sm"
                                                    name="action"
                                                    onClick={() =>
                                                        loadModalData(
                                                            `developer_${o.id}`,
                                                            o.o2o_developerfinance__mdm_id,
                                                            "get_data"
                                                        )
                                                    }
                                                >
                                                    {apiData.disabled || o.receipt_id
                                                        ? t("Вознаграждения")
                                                        : t("Сформировать чек")}
                                                </DevForm.Button>
                                            </>
                                        )}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
            </ListingCard>
            <ReceiptModal
                createReceiptModal={createReceiptModal}
                setCreateReceiptInfo={setCreateReceiptInfo}
                apiData={apiData}
                setApiData={setApiData}
                apiUrl={apiUrl}
                api_post={api_post}
            />
        </>
    );
}

const ReceiptModal = ({ createReceiptModal, setCreateReceiptInfo, apiData, apiUrl, api_post }) => {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const handleClose = () => setCreateReceiptInfo(false);
    const makeReceipt = (ev, mdm_id, action) => {
        setIsLoading(true);
        api_post(null, apiUrl, {
            params: {
                action,
                mdm_id,
                month: apiData.forms_data.main.data.month,
                year: apiData.forms_data.main.data.year,
            },
            then: (resp) => {
                if (resp.status === "ok") {
                    window.location.reload();
                }
            },
        });
    };
    return (
        <DevModal
            size="xl"
            show={createReceiptModal}
            onHide={handleClose}
            header={createReceiptModal.data ? t("Данные чека") : ""}
            body={
                createReceiptModal.data && (
                    <>
                        {createReceiptModal.sum === "0" ? (
                            <div className="mt-3">
                                <div className="jumbotron p-3 mb-0">
                                    <h4>{t("Нет данных")}</h4>
                                </div>
                            </div>
                        ) : (
                            <>
                                <Table hover responsive>
                                    <thead>
                                        <tr>
                                            <th>{t("Год")}</th>
                                            <th>{t("Месяц")}</th>
                                            <th>{t("Доход разработчика")}</th>
                                            <th>{t("Вознаграждение")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {createReceiptModal.data.map((obj, ind) => (
                                            <tr key={ind}>
                                                <td>{obj.year}</td>
                                                <td>{obj.month}</td>
                                                <td>{obj.royalty}</td>
                                                <td>{obj.agent_fee}</td>
                                            </tr>
                                        ))}
                                        <tr>
                                            <td>
                                                <strong>{t("Всего")}</strong>
                                            </td>
                                            <td></td>
                                            <td>
                                                <strong>{money_fmt(createReceiptModal.sum)}</strong>
                                            </td>
                                            <td>
                                                <strong>{money_fmt(createReceiptModal.sum_agent_fee)}</strong>
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                                {!apiData.disabled && !createReceiptModal.receipt_id && (
                                    <DevForm.Button
                                        variant="success"
                                        name="make_receipt"
                                        action="make_receipt"
                                        isLoading={isLoading}
                                        onClick={() =>
                                            makeReceipt(
                                                `developer_${createReceiptModal.developer_id}`,
                                                createReceiptModal.o2o_developerfinance__mdm_id,
                                                "make_receipt"
                                            )
                                        }
                                    >
                                        {t("Сформировать чек")}
                                    </DevForm.Button>
                                )}
                            </>
                        )}
                    </>
                )
            }
        />
    );
};
